import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    avatar: '',
    username: '',
    email: '',
    authority: [],
    config: {}
}

export const userSlice = createSlice({
	name: 'auth/user',
	initialState,
	reducers: {
        setUser: (_, action) => action.payload,
        setUserConfig: (state, action) => {
            return {
                ...state,
                config: action.payload
            };
        },
        userLoggedOut: () => initialState,
	},
})

export const { setUser, setUserConfig } = userSlice.actions

export default userSlice.reducer